import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const PasswordUpdate = styled.div`
  img {
    height: 15rem;
    margin: auto;
  }
  .password-rules-list {
    display: flex;
    list-style: none;
    margin-bottom: 10px;

    div {
      font-size: 11px;
      font-weight: 600;
    }
  }

  label {
    input {
      margin: 20px auto 10px;
    }
  }
  .ant-input {
    margin-top: 10px;
    height: 50px !important;
    display: block;
    opacity: 0.75;
    font-size: 16px;
    width: 100%;
    font-weight: 500;
    letter-spacing: 0.6px;
    color: white;
  }

  .ant-input:-webkit-autofill:focus {
    font-family: 'Open Sans', sans-serif !important;
    height: 50px !important;
    display: block;
    opacity: 0.75;
    font-size: 16px !important;
    font-weight: 500;
    letter-spacing: 0.6px;
    background-color: white !important;
  }
  .ant-btn {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    background-color: #545cd8;
    border: none;
    margin-bottom: 15px;
  }

  label {
    font-weight: 600;
    font-size: 14px;
    width: 100%;
  }

  .inputError {
    position: absolute;
    color: #dc3545;
    font-weight: 600;
    font-size: 12px;
  }
  .check-tag {
    font-size: 11px;
    padding: 5px;
    border-radius: 20px;
    margin: 20px 2px;
  }
  .button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
  }
`
